const o = {
  id: "FloridaLotto",
  name: "Florida Lotto",
  style: {
    colorPrimary: "#00ae8d"
  }
};
export {
  o as default
};
